import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";
import { StateToObj } from "./reduxHelper";

const initialState = {
    "id" : uuidv4(),
    "data": []
}
const updateReplyMessage = (newMessage, replyMessageArray = []) => {
    const firstObject = newMessage;
    if (!firstObject) return [];
    const checkalreadyExist = replyMessageArray.find(message => (message && message.replyMsgId === firstObject.replyMsgId));
    if (!checkalreadyExist) {
        return [...replyMessageArray, firstObject]
    }
    return replyMessageArray; //.concat(firstObject);
}
const replyMessageData = createSlice({
    name:'replyMessageData',
    initialState,
    reducers:{
        addReplyMessageData: (state,payload = {})=>{  
            const { id, data } = StateToObj(state)      
               return {
                ...state,
                ...{
                    "id" : id,
                    "data": updateReplyMessage(payload.payload, data)
                }
               }
        }
    }
});

export default replyMessageData.reducer
export const addReplyMessageData = replyMessageData.actions.addReplyMessageData